export const actionTypes = {
    ENABLE_DISABLE_DRIVE_REQUEST: 'powertrainTools/gatewayManagement/ENABLE_DISABLE_DRIVE_REQUEST',
    ENABLE_DISABLE_DRIVE: 'powertrainTools/gatewayManagement/ENABLE_DISABLE_DRIVE'
};
